import React from "react";
import Error from "@/components/Pages/Public/Error";

const PagesError: React.FC = () => {
  return <Error />;
};

export default PagesError;
